export default __webpack_public_path__ + "static/media/contacts-icon-black.5a321984.svg";